import { render, staticRenderFns } from "./location-review.vue?vue&type=template&id=5bebec84"
import script from "./location-review.vue?vue&type=script&lang=ts"
export * from "./location-review.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports